// Task type constants
export const TaskTypes = {
  SWAP: "amount_swapped_of_token",
  DAILY_BUY: "daily_buy_token",
  HOLD_TOKEN: "hold_token",
  SECRET_CODE: "secret_code",
  FOLLOW_TWITTER: "follow_twitter_account",
  RETWEET: "retweet_post",
  RETWEET_MVX: "retweet_twitter_post",
  JOIN_TELEGRAM: "join_telegram",
  CREATE_MEDIA: "create_media",
  JOIN_FILMIO: "join_film_community",
  JOIN_DISCORD: "join_discord",
  QUIZ: "quiz",
  CLICK_LINK: "click_link",
  TWITTER_USERNAME: "twitter_username",
  TWEET_KEYWORDS: "tweet_keywords",
  TOTAL_DELEGATION_TASK: "total_delegation_task",
  BALANCE_TOKEN: "balance_check",
  DAILY_CHECKIN: "daily_checkin",
  HOLD_NFT: "ape_wealth_snapshot",
  SHARE_PROGRESS: "share_progress",
  LIKE_POST: "like_post",
  DISCORD_REFERRAL: "discord_referral",
  TRADING: "trading",
  DISCORD_ROLE: "discord_role",
  JOIN_LINKEDIN: "has_linkedin",
  FOLLOW_LINKEDIN: "follow_linkedin",
  GOL_CHECK: "gol_check",
  OTC_POINTS: "otc_points",
} as const;
